import Immutable from 'immutable';
import {
  FLAG_GETTING_DRIVER_TYPES,
  GET_DRIVER_TYPES,
  CLEAR_DRIVER_TYPES,
  FLAG_DRIVER_TYPE_ACTIVITY,
  CLEAR_DRIVER_TYPE,
  GET_DRIVER_TYPE,
} from '../../../actions/types/traffic';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_DRIVER_TYPES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_DRIVER_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_DRIVER_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DRIVER_TYPE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DRIVER_TYPE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_DRIVER_TYPE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
